module.exports = __webpack_public_path__ + "img/OnArchitecture6.d359e63b.jpg";